import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserFossilFinderGameProps {
    onComplete: () => void;
}

interface PhaserFossilFinderGameState {
}

const gameConfig: GameConfig = {
    title: "Fossil Finder Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserFossilFinderGame extends React.Component<PhaserFossilFinderGameProps, PhaserFossilFinderGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserFossilFinderGameProps) {
        super(props);
        bindAllOfThis(this, PhaserFossilFinderGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserFossilFinderGame;



// WEBPACK FOOTER //
// ./src/games/FossilFinderGame/Main.tsx